import { css } from '@emotion/react'
import { Heading } from '@livechat/design-system-react-components'

import { getItemById } from '@/store/typedSelectors'
import useParamSelector from '@/hooks/useParamSelector'

const headingCss = css`
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

interface Props {
  id: string
  isReviewFormOpen: boolean
}

const RatingModalHeader = ({ id, isReviewFormOpen }: Props) => {
  const productName = useParamSelector(getItemById, id)?.name || 'application'

  return (
    <Heading css={headingCss}>
      {isReviewFormOpen
        ? `Leave a review for ${productName}`
        : 'Ratings & Reviews'}
    </Heading>
  )
}

export default RatingModalHeader
